import IdleTimer from 'react-idle-timer';
import React, { useEffect, useMemo } from 'react';

import UserMenuIcon from 'components/Granel/UserMenuIcon';
import { signOut } from 'utils/functions';
import Notifications from 'components/Granel/Notifications';

import api from 'services/api';
import { useTour } from 'hooks/useTour';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import NewNotifications from 'newComponents/NewNotifications';
import {
  Address,
  BoxAddressBreadcrumb,
  BoxNameAddress,
  BoxNotificationProfile,
  BoxTwoBars,
  Container,
  ContainerWrap,
  Divider,
  IntroButton,
  Name,
  ResponsiveGradient,
  TourBellWrap,
  TwoBars,
} from './styles';

type UserMenuNewProps = {
  intro?: () => void;
};

const UserMenuNew = ({ intro }: UserMenuNewProps): JSX.Element => {
  useEffect(() => {
    (async () => {
      const path = window.location.pathname;
      const userId = localStorage.getItem('@UltragazEmpresarial:userId');
      const buttonElement = document.getElementById('intro-button');

      if (
        path !== '/nova-empresa' &&
        path !== '/perfil' &&
        path !== '/dicas-seguranca'
      ) {
        const userResponse = await api.get(
          `industrial/customer/v1/users/${userId}`,
          {
            headers: {
              access_token: localStorage.getItem(
                '@UltragazEmpresarial:accessToken'
              ),
            },
          }
        );

        if (userResponse.status === 200) {
          const { guideNavigationTour } = userResponse.data;

          if (guideNavigationTour === false) {
            if (buttonElement) {
              buttonElement.click();

              api.patch(
                `industrial/customer/v1/users/${userId}`,
                {
                  guideNavigationTour: true,
                },
                {
                  headers: {
                    access_token: localStorage.getItem(
                      '@UltragazEmpresarial:accessToken'
                    ),
                  },
                }
              );
            }
          }
        }
      }
    })();
  }, []);

  const { showTour, tourStep, setShowTour, tourType } = useTour();

  const handleOnIdle = (): void => {
    signOut();
  };

  const address = useMemo(() => {
    const customerAddressLine = localStorage.getItem(
      '@UltragazEmpresarial:customerAddressLine'
    );

    if (customerAddressLine) {
      return customerAddressLine
        .toLowerCase()
        .replace(/(?:^|\s)\S/g, function (a) {
          return a.toUpperCase();
        });
    }

    return '';
  }, []);

  const name = useMemo(() => {
    const customerName = localStorage.getItem(
      '@UltragazEmpresarial:customerName'
    );

    if (customerName) {
      return customerName;
    }

    return '';
  }, []);

  return (
    <ContainerWrap id="user-menu">
      <Container showTour={showTour && tourType === 'home' && tourStep === 2}>
        <IdleTimer
          timeout={15 * 60 * 1000}
          onIdle={handleOnIdle}
          debounce={250}
        />
        <ResponsiveGradient>
          <BoxTwoBars>
            <BoxNameAddress>
              <Name>{name}</Name>
              <BoxAddressBreadcrumb>
                <Address>{address}</Address>
              </BoxAddressBreadcrumb>
            </BoxNameAddress>
          </BoxTwoBars>
          <BoxNotificationProfile>
            {intro && (
              <IntroButton id="intro-button" onClick={() => setShowTour(true)}>
                <span className="mdi mdi-compass-outline" />
                Ver tour da página
              </IntroButton>
            )}
            <TourBellWrap
              showTour={showTour && tourType === 'home' && tourStep === 3}
            >
              <NewNotifications />
              {showTour && tourType === 'home' && tourStep === 3 && (
                <TourBalloon
                  title="Notificações"
                  content="No <span class='mdi mdi-bell'></span>, você localiza todas as notificações de solicitações feitas no portal."
                  position={{
                    left: '50%',
                    right: '0',
                    top: '30px',
                    arrowPosition: 'top',
                    maxWidth: 'unset',
                    transform: 'translateX(-50%)',
                    width: '220px',
                  }}
                />
              )}
            </TourBellWrap>
            <Divider />
            <UserMenuIcon />
          </BoxNotificationProfile>
        </ResponsiveGradient>
      </Container>
      {showTour && tourType === 'home' && tourStep === 2 && (
        <TourBalloon
          title="Dados cadastrais"
          content="Aqui são exibidas suas Informações Cadastrais."
          position={{
            left: '20px',
            right: '0',
            top: '50px',
            arrowPosition: 'top',
            maxWidth: 'unset',
            width: '200px',
          }}
        />
      )}
    </ContainerWrap>
  );
};

UserMenuNew.defaultProps = {
  intro: null,
};

export default UserMenuNew;
